module.exports = __webpack_public_path__ + "static/media/mongo.6bbdac92.png";